import React from 'react';
import { Helmet } from 'react-helmet-async';
import Button from './Button';

const address = ['business', '@', 'roaming', 'quark', '.', 'info']

function createAddress() {
  return address.join('');
}

function sendEmail() {
  window.open('mailto:' + createAddress() + '?subject=Business Inquiry&body=Hi', '_self')
}

const Contacts = () => {
    return (
        <div>
      <Helmet>
        <title>Contacts | .rq Lab</title>
        <meta
          name="description"
          content="Contact .rq Lab for business inquiries, collaboration, and project discussions."
        />
        <link rel="canonical" href="https://roamingquark.info/contacts" />
      </Helmet>
            <h2>Contacts</h2>
            <p><Button onClick={sendEmail}>Send E-mail</Button></p>
            <p><a className="App-link" href="https://www.linkedin.com/in/andreygalysh/" target="_blank" rel="noopener noreferrer">LinkedIn</a></p>
            <p><a className="App-link" href="https://github.com/theang" target="_blank" rel="noopener noreferrer">GitHub</a></p>
        </div>
    )
}

export default Contacts;
export {address, sendEmail, Contacts};